// One-line, short-lived messages ("need $80", "outside the map").
export interface Toast {
  show(text: string): void;
}

export function createToast(parent: HTMLElement): Toast {
  const el = document.createElement('div');
  el.className = 'toast';
  parent.appendChild(el);
  let timer = 0;
  return {
    show(text) {
      el.textContent = text;
      el.classList.add('show');
      window.clearTimeout(timer);
      timer = window.setTimeout(() => el.classList.remove('show'), 1600);
    },
  };
}
